import { render } from "./admin-settings.vue?vue&type=template&id=edc7033a&scoped=true"
import script from "./admin-settings.vue?vue&type=script&lang=js"
export * from "./admin-settings.vue?vue&type=script&lang=js"

import "./admin-settings.vue?vue&type=style&index=0&id=edc7033a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\admin-tapit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edc7033a"]])

export default __exports__